// extracted by mini-css-extract-plugin
export var border = "_1n-8";
export var brand = "_1n-t";
export var button = "_1n-l";
export var center = "_1n-a";
export var centered = "_1n-6";
export var closeButton = "_1n-c";
export var disabledWrapper = "_1n-m";
export var error = "_1n-p";
export var extraLarge = "_1n-4";
export var extraSmall = "_1n-1";
export var fill = "_1n-i";
export var footer = "_1n-h";
export var footerAction = "_1n-j";
export var footerButtons = "_1n-k";
export var header = "_1n-7";
export var headerWithClose = "_1n-d";
export var icon = "_1n-o";
export var info = "_1n-s";
export var inline = "_1n-9";
export var large = "_1n-3";
export var main = "_1n-e";
export var modal = "_1n-0";
export var nearFull = "_1n-5";
export var neutral = "_1n-u";
export var noPadding = "_1n-g";
export var none = "_1n-v";
export var scrollable = "_1n-f";
export var small = "_1n-2";
export var success = "_1n-r";
export var tight = "_1n-n";
export var titleIcon = "_1n-b";
export var warn = "_1n-q";